import { Avatar, TableCell, TableRow } from '@mui/material';
import React, { useEffect, useState } from 'react';
import EditProduct from './EditProduct';
import ConvertToAdminAdded from './ConvertToAdminAdded';
import Label from '../elements/label/Label';

export default function ProductListContent({ row, columns, index, fetchData, setMessage, setSnackbarOpen }) {
  const { id, title, category_data, price, pictures, status } = row;
  const [iconLoaded, setIconLoaded] = useState(false);

  useEffect(() => {
    if (firstPicture) {
      const img = new Image();
      img.src = firstPicture;
      img.onload = () => setIconLoaded(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const firstPicture = pictures && pictures.length > 0 ? pictures[0] : null;

  const getColumnContent = (column) => {
    const { id: columnId, nested } = column;

    if (columnId === 'sno') {
      return index + 1;
    } else if (columnId === 'pictures') {
      return iconLoaded ? (
        <Avatar
          alt={title}
          src={firstPicture}
          sx={{ mx: 'auto', width: 50, height: 50 }}
        />
      ) : (
        <Avatar
          alt={title}
          src="/default_product_category.png"
          sx={{ mx: 'auto', width: 50, height: 50 }}
        />
      );
    } else if (columnId === 'title') {
      return title.charAt(0).toUpperCase() + title.slice(1);
    } else if (columnId === 'category_data.name') {
      return category_data?.name || 'NA';
    } else if (columnId === 'price') {
      const formattedPrice = parseFloat(price).toLocaleString('en-US', {maximumFractionDigits: 2});
      return `$${formattedPrice}`;
    } else if (columnId === 'status') {
      return <Label color={status === 'active' ? 'success' : 'default'}>
            {status}
          </Label>
      } else if (columnId === 'description') {
      const description = row[columnId] || 'NA';
      return (
        <div
          style={{
            overflow: 'hidden',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
            textOverflow: 'ellipsis',
            maxWidth: '200px',
            margin: '0 auto',
          }}>
          {description}
        </div>
      );
    } else if (nested) {
      const nestedProperties = columnId.split('.');
      let nestedValue = row;
      for (const property of nestedProperties) {
        if (nestedValue && nestedValue.hasOwnProperty(property)) {
          nestedValue = nestedValue[property];
        } else {
          nestedValue = null;
          break;
        }
      }
      return nestedValue;
    } else if (columnId === 'actions') {
      return (
        <>
          <EditProduct
            product={row}
            fetchData={fetchData}
            setMessage={setMessage}
            setSnackbarOpen={setSnackbarOpen}
          />
          <ConvertToAdminAdded
            product={row}
            fetchData={fetchData}
            setMessage={setMessage}
            setSnackbarOpen={setSnackbarOpen}
          />
        </>
      );
    } else {
      return row[columnId] || 'NA';
    }
  };

  return (
    <TableRow hover key={id}>
      {columns.map((column, columnIndex) => (
        <TableCell
          key={column.id}
          align="center"
          sx={
            columns.length === columnIndex
              ? {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: column.id === 'pictures' ? '80px' : 'auto',
                }
              : {}
          }>
          {getColumnContent(column)}
        </TableCell>
      ))}
    </TableRow>
  );
}
